module.exports = __webpack_public_path__ + "static/img/CLAY-HALL.20474ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CLAY-HALL.jpg
// module id = YzGo
// module chunks = 0